import { useId, type ReactNode } from "react";

interface ListCardProps {
  /** The card's heading; or `lead` in its place, such as a search field, with `label` naming the card. */
  title?: string;
  lead?: ReactNode;
  label?: string;
  /** Buttons at the right of the header, such as "Add". */
  actions?: ReactNode;
  /** Rows that reach the card's edges, such as a divided list. */
  children: ReactNode;
}

/** A card whose rows reach its edges, under a header with a title or a field and its actions. */
export default function ListCard({ title, lead, label, actions, children }: ListCardProps) {
  const titleId = useId();
  return (
    <section className="app-card min-w-0" aria-labelledby={title === undefined ? undefined : titleId} aria-label={title === undefined ? label : undefined}>
      <header className="flex items-center justify-between gap-2 px-4 py-3">
        {title === undefined ? lead : <h3 id={titleId} className="app-title text-sm font-semibold">{title}</h3>}
        {actions}
      </header>
      {children}
    </section>
  );
}
